export const getAge = (birthDate, now = new Date()) => {
  let age = now.getFullYear() - birthDate.getFullYear()
  const months = now.getMonth() - birthDate.getMonth()
  if (months < 0 || (months === 0 && now.getDate() < birthDate.getDate())) {
    age -= 1
  }
  return age
}
